import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiMenu, FiX, FiUser, FiBook, FiHome, FiFileText, FiPhone, FiInfo } from 'react-icons/fi';
import { FaBrain } from 'react-icons/fa';
import { API_BASE_URL, BASE_URL,institute_id } from '../config/config';
const PublicHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [settings, setSettings] = useState(null);
  const isLoggedIn = !!user;


  useEffect(() => {
    fetchSiteSettings();
  }, []);

  const fetchSiteSettings = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/site-settings?institute_id=${institute_id}`);
      const data = await response.json();
      if (data.success) {
        setSettings(data.data);
        localStorage.setItem('settings', JSON.stringify(data.data));
      }
    } catch (error) {
      console.error('Error fetching site settings:', error);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const handleWhatsAppClick = () => {
    // Get phone number from localStorage settings
    const savedSettings = localStorage.getItem('settings');
    if (savedSettings) {
      try {
        const settingsData = JSON.parse(savedSettings);
        const phoneNumber = settingsData.phone;
        
        if (phoneNumber) {
          // Remove any non-numeric characters and format for WhatsApp
          const cleanPhone = phoneNumber.replace(/\D/g, '');
          // Open WhatsApp with pre-filled message
          window.open(`https://wa.me/${cleanPhone}?text=Hello, I need help!`, '_blank');
        } else {
          alert('WhatsApp number not configured');
        }
      } catch (error) {
        console.error('Error reading settings:', error);
        alert('Unable to open WhatsApp. Please try again.');
      }
    } else {
      alert('Settings not available. Please refresh the page.');
    }
  };

  const navLinks = [
    { path: '/', label: 'Home', icon: FiHome },
    { path: '/courses', label: 'Courses', icon: FiBook },
    { path: '/blog', label: 'Blog', icon: FiFileText },
    { path: '/about', label: 'About Us', icon: FiInfo },
    { path: '/contact', label: 'Contact', icon: FiPhone },
  ];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
       
          <Link to="/" className="flex items-center space-x-2">
            {settings?.logo ? (
              <>
                <img 
                  src={`${settings.logo}`}
                  alt={settings.site_name || 'Logo'}
                  className="h-10 w-auto"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.querySelector('.fallback-logo').style.display = 'flex';
                  }}
                />
                <div className="fallback-logo w-10 h-10 bg-gradient-to-br from-primary-500 to-purple-600 rounded-lg items-center justify-center" style={{ display: 'none' }}>
                  {/* <span className="text-white font-bold text-xl">R</span> */}
                </div>
              </>
            ) : (
              <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-purple-600 rounded-lg flex items-center justify-center">
                {/* <span className="text-white font-bold text-xl">R</span> */}
              </div>
            )}
            {/* <div className="hidden sm:block">
              <h1 className="text-xl font-bold text-gray-800">
                {settings?.site_name || 'Raj Economics'}
              </h1>
              <p className="text-xs text-gray-500">
                {settings?.site_tagline || 'RECC'}
              </p>
            </div> */}
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="px-4 py-2 rounded-lg text-gray-700 hover:bg-primary-50 hover:text-primary-600 transition-colors font-medium"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Auth Buttons */}
          <div className="hidden md:flex items-center space-x-3">
            {/* Help Icon - Opens WhatsApp */}
            <button
              onClick={handleWhatsAppClick}
              className="p-2 rounded-full hover:bg-blue-50 transition-colors"
              title="Get Help on WhatsApp"
            >
              <img 
                src="/help-icon.png" 
                alt="Help" 
                className="w-6 h-6"
              />
            </button>

            {isLoggedIn ? (
              <>
                <Link
                  to="/dashboard"
                  className="px-4 py-2 text-gray-700 hover:text-primary-600 transition-colors font-medium"
                >
                  Dashboard
                </Link>
                <Link
                  to="/ai/features"
                  className="px-4 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg hover:shadow-lg transition-all font-medium flex items-center gap-2"
                >
                  <FaBrain />
                  AI Tools
                </Link>
                <Link
                  to="/my-courses"
                  className="px-4 py-2 text-gray-700 hover:text-primary-600 transition-colors font-medium"
                >
                  My Courses
                </Link>
                <button
                  onClick={handleLogout}
                  className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="px-4 py-2 text-gray-700 hover:text-primary-600 transition-colors font-medium"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="px-4 py-2 bg-gradient-to-r from-primary-500 to-purple-600 text-white rounded-lg hover:shadow-lg transition-all font-medium"
                >
                  Register
                </Link>
              </>
            )}
          </div>

          {/* Mobile Help Icon and Menu Button */}
          <div className="md:hidden flex items-center space-x-2">
            {/* Help Icon - Visible on Mobile */}
            <button
              onClick={handleWhatsAppClick}
              className="p-2 rounded-lg hover:bg-blue-50 transition-colors"
              title="Get Help on WhatsApp"
            >
              <img 
                src="/help-icon.png" 
                alt="Help" 
                className="w-6 h-6"
              />
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setShowMenu(!showMenu)}
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {showMenu ? (
                <FiX className="w-6 h-6 text-gray-700" />
              ) : (
                <FiMenu className="w-6 h-6 text-gray-700" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {showMenu && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col space-y-2">
              {navLinks.map((link) => {
                const Icon = link.icon;
                return (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setShowMenu(false)}
                    className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-primary-50 hover:text-primary-600 transition-colors"
                  >
                    <Icon className="w-5 h-5" />
                    <span className="font-medium">{link.label}</span>
                  </Link>
                );
              })}
              
              {/* Help Button - Opens WhatsApp */}
              <button
                onClick={() => {
                  handleWhatsAppClick();
                  setShowMenu(false);
                }}
                className="flex items-center space-x-3 px-4 py-3 rounded-lg hover:bg-blue-50 transition-colors"
              >
                <img 
                  src="/help-icon.png" 
                  alt="Help" 
                  className="w-5 h-5"
                />
                <span className="font-medium">Help & Support</span>
              </button>
              
              <div className="border-t pt-2 mt-2">
                {isLoggedIn ? (
                  <>
                    <Link
                      to="/dashboard"
                      onClick={() => setShowMenu(false)}
                      className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-primary-50 transition-colors"
                    >
                      <FiUser className="w-5 h-5" />
                      <span className="font-medium">Dashboard</span>
                    </Link>
                    <Link
                      to="/ai/features"
                      onClick={() => setShowMenu(false)}
                      className="flex items-center space-x-3 px-4 py-3 rounded-lg bg-gradient-to-r from-purple-600 to-blue-600 text-white hover:shadow-lg transition-all"
                    >
                      <FaBrain className="w-5 h-5" />
                      <span className="font-semibold">AI Tools</span>
                    </Link>
                    <Link
                      to="/my-courses"
                      onClick={() => setShowMenu(false)}
                      className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-primary-50 transition-colors"
                    >
                      <FiBook className="w-5 h-5" />
                      <span className="font-medium">My Courses</span>
                    </Link>
                    <button
                      onClick={() => {
                        handleLogout();
                        setShowMenu(false);
                      }}
                      className="w-full text-left flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors"
                    >
                      <span className="font-medium">Logout</span>
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="/login"
                      onClick={() => setShowMenu(false)}
                      className="block px-4 py-3 rounded-lg text-gray-700 hover:bg-primary-50 transition-colors font-medium"
                    >
                      Login
                    </Link>
                    <Link
                      to="/register"
                      onClick={() => setShowMenu(false)}
                      className="block px-4 py-3 bg-gradient-to-r from-primary-500 to-purple-600 text-white rounded-lg text-center font-medium mt-2"
                    >
                      Register
                    </Link>
                  </>
                )}
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default PublicHeader;

